import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(
    private router: Router
  ) { }

  public navigateToNext(url: string) {
    const myurl = `${url}`;
    this.router.navigateByUrl(myurl).then(_e => {
      // This is intentional
    });
  }
}
